module.exports = __webpack_public_path__ + "img/Podcast.fa2acb49.svg";